module.exports = __webpack_public_path__ + "static/media/41.4aeb0938.gif";